<template>
  <div id="app">
      <router-view/>
  </div>
</template>

<script>
// import {getInforType} from '@/api/axios-api'
export default{
  data () {
    return {
      // langText: '简体',
      // lang : 'zh-cn',
      // language: [{name: '简体', type: 'zh-cn'},{name: '繁体', type: 'zh-tw'}],
      // infoMenuList: []
    }
  },
  created () {
    // console.log(this.$route.name)
    // var langObj = {}
    // if (localStorage.getItem('lang') == 'zh-cn' || localStorage.getItem('lang') == undefined) {
    //   this.langText = '简体'
    //   langObj.lang = this.lang
    // } else {
    //   this.langText = '繁体'
    //   langObj.lang = localStorage.getItem('lang')
    // }
    // // 获取新闻菜单
    // getInforType(langObj).then(res => {
    //   if(res.status == 200) {
    //     this.infoMenuList = res.data
    //     // localStorage.setItem('infoTypeList',JSON.stringify(res.data))
    //   }
    // })
  },
  methods: {
    /**
     * 语言切换
     */
    // handChangeLanguage (langVal) {
    //   // console.log(langVal)
    //   this.$i18n.locale = langVal
    //   localStorage.setItem('lang',langVal)
    //   if (langVal == 'zh-cn') {
    //     this.langText = '简体'
    //   } else {
    //     this.langText = '繁体'
    //   }
    //   // window.reload()
    //   location.reload()
    // }
  }
}
</script>

<style lang="scss">
html {
  height: 100%;
}
body {
  height: 100%;
}
#app {
  height: 100%;
}

</style>
